import {RREventType} from "../types/RREventType";
import {dateWithMaxTime, dateWithZeroTime} from "../tools";

export const getEventShortName = (event: RREventType, activeDerpartment: "" | "montage" | "catering" | "store" | "logistics") => {
    if (event.id === "WAREHOUSE" && activeDerpartment === "store") {
        return "Кухня";
    }
    return event.eventName;
}
export const getEventName = (event: RREventType, activeDerpartment: "" | "montage" | "catering" | "store" | "logistics") => {
    if (event.id === "WAREHOUSE" && activeDerpartment === "store") {
        return "Кухня";
    }
    return `${event.eventName} (${event.eventNumber})`;
}
export function getEventClassColorName(event: RREventType) {
    let bgTextColor = "bg-primary text-white";
    if (event.eventStatus === "WAREHOUSE" || event.id === "WAREHOUSE") {
        bgTextColor = "bg-warning text-dark";
    } else if (event.eventStatus !== "ПОТВЪРДЕНО" && event.eventStatus !== "ПОДГОТВЕНО") {
        bgTextColor = "bg-secondary text-white";
    }
    return bgTextColor;
}
export function getEventClassName(event: RREventType) {
    const bgTextColor = getEventClassColorName(event);
    return `border rounded text-nowrap d-block text-truncate p-1 ${bgTextColor}`;
}

export function filterEventsForADay(allEvents: RREventType[], day: Date, activeDerpartment: string) {
    const events = allEvents.filter(event => {
        const eventFirstDate = dateWithZeroTime(event.firstDate);
        const eventLastDate = dateWithMaxTime(event.lastDate ?? event.firstDate);
        if (!eventFirstDate || !eventLastDate) {
            return false;
        }
        return eventFirstDate <= day && eventLastDate >= day;
    });
    if (activeDerpartment === "montage") {
        const newWarehouseEvent = {
            id: "WAREHOUSE",
            eventShortName: "Склад",
            eventStatus: "WAREHOUSE",
            firstDate: day,
            lastDate: day,
            isMontage: true,
            isCatering: false,
            isStore: false,
            isWarehouse: true,
            eventCategory: "MONTAGE",
            eventName: "Склад",
            eventNumber: "WAREHOUSE",
            clientEmail: "",
            clientName: "",
            clientPhone: "",
            clientAddress: "",
            clientContactPerson: "",
            clientContactPhone: "",
        } as RREventType;

        events.push(newWarehouseEvent);
    }
    return events;
}
